import { render, staticRenderFns } from "./TabPrepaid.vue?vue&type=template&id=1eb77e66&"
import script from "./TabPrepaid.vue?vue&type=script&lang=js&"
export * from "./TabPrepaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports